import { getAuthChallenge, getClient, updateAuthChallenge, updateAccessToken, updateRefreshToken } from 'utils'
import { StaticPageError } from 'components/styled'
import { redirect, useLoaderData, type LoaderFunctionArgs } from 'react-router-dom'

type LoginLoaderData = { error: string } | null

export const loginLoader = async ({ request }: LoaderFunctionArgs): Promise<LoginLoaderData> => {
    const url = new URL(request.url)
    const code = url.searchParams.get('code')
    const to = url.searchParams.get('to')
    const error = url.searchParams.get('error')
    const errorDescription = url.searchParams.get('error_description')

    if (error) {
        return { error: errorDescription ?? error }
    }

    if (!code || !to) {
        const redirectURI = `${url.origin}${url.pathname}?to=${to ?? '/'}`
        const { challenge, url: authUrl } = await getClient().authorize(redirectURI, 'code', { pkce: true })
        updateAuthChallenge(JSON.stringify(challenge))
        throw redirect(authUrl)
    }

    const redirectURI = `${url.origin}${url.pathname}?to=${to}`
    const authChallengeRaw = getAuthChallenge()
    const authChallenge = authChallengeRaw ? JSON.parse(authChallengeRaw) : null
    if (authChallenge) {
        updateAuthChallenge(null)
    }

    const exchanged = await getClient().exchange(
        code,
        redirectURI,
        authChallenge?.verifier ?? ''
    )

    if (exchanged.err) {
        return { error: 'Token exchange failed' }
    }

    updateAccessToken(exchanged.tokens.access)
    updateRefreshToken(exchanged.tokens.refresh)
    throw redirect(to)
}

export const Login = () => {
    const data = useLoaderData() as LoginLoaderData
    if (data?.error) {
        return <StaticPageError message={data.error}/>
    }
    return <></>
}
